import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Spacer } from '../../../../components/Spacer';
import { Typography } from '../../../../components/Typography';
import { experiencesPropTypes } from '../../../../data/models/Experience';
import { restaurantPropTypes } from '../../../../data/models/Restaurant';
import { ExperienceList } from './ExperienceList';

const SelectExperience = ({ restaurant, experiences }) => {
  if (restaurant.data.dateSelectorType !== 'experiences' && experiences?.data?.length <= 0) {
    return <></>;
  }

  return (
    <Spacer direction='vertical' gap='m' style={{ marginTop: '12px' }}>
      <Typography variant='h4'>Select an experience</Typography>

      <ExperienceList />
    </Spacer>
  );
};

SelectExperience.propTypes = {
  restaurant: restaurantPropTypes.isRequired,
  experiences: experiencesPropTypes.isRequired,
};

const mapStateToProps = (state) => ({
  restaurant: state.restaurant,
  experiences: state.experiences,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SelectExperience);
